import { Code, ConnectError } from '@connectrpc/connect';
import type { Interceptor } from '@connectrpc/connect';

/**
 * Intercepts UNAUTHENTICATED gRPC responses and redirects to /logout,
 * equivalent to the errorCode 1005 force-logout path in TockApiMiddleware:
 *
 *   if (errorCode === 1005) { this.logoutAction(); }
 *
 * Using window.location.assign ensures a full navigation so that LogoutRoute
 * mounts, calls actions.app.logout(), and then redirects to /login.
 */
const unauthenticatedRedirectInterceptor: Interceptor = (next) => async (req) => {
  try {
    return await next(req);
  } catch (err) {
    if (err instanceof ConnectError && err.code === Code.Unauthenticated) {
      window.location.assign('/logout');
    }
    throw err;
  }
};

export { unauthenticatedRedirectInterceptor };
